import { Navigate, Route, Routes } from 'react-router'

import WelcomePage from './pages/00-Welcome'
import CompanyPage from './pages/01-Company'
import CompanyDetailsPage from './pages/02-CompanyDetails'
import TurnoverPage from './pages/03-Turnover'
import PersonalInformationsPage from './pages/04-PersonalInformations'
import ProduitsProfessionnelPage from './pages/06-ProduitsProfessionnel'
import ActivityPage from './pages/07-Activity'
import HeyflowPage from './pages/08-Heyflow'
import EcommerceTurnoverPage from './pages/09-EcommerceTurnover'
import MRPBuildingAddressPage from './pages/10-MRPBuildingAddress'
import MRPBuildingInformationsPage from './pages/11-MRPBuildingInformations'
import LoadingPage from './pages/12-Loading'
import TailoredCoverDatePage from './pages/13-TailoredCoverDate'
import TailoredBookMeetingPage from './pages/14-TailoredBookMeeting'
import TailoredFinalizationPage from './pages/15-TailoredFinalization'
import PricingRCPPage from './pages/16-PricingRCP'
import PricingEcommPage from './pages/17-PricingEcomm'
import PricingMRPPage from './pages/18-PricingMRP'
import TerminationPage from './pages/19-Termination'
import StartDatePage from './pages/20-StartDate'
import SummaryPage from './pages/21-Summary'
import AuthenticatePage from './pages/22-Authenticate'
import OtpPage from './pages/23-Otp'
import CheckoutPage from './pages/24-Checkout'
import SignaturePage from './pages/25-Signature'
import SuccessPage from './pages/26-Success'
import AsdBuildingAddressPage from './pages/27-ASDBuildingAddress'
import PricingAsdPage from './pages/28-PricingASD'
import UserTypePage from './pages/29-UserType'
import ProduitsParticulierPage from './pages/30-ProduitsParticulier'
import AsdProBuildingAddressPage from './pages/31-ASDProBuildingAddress'
import PricingAsdProPage from './pages/32-PricingASDPro'
import UserTypePciPage from './pages/33-UserTypePci'
import ProduitsCollectivitePage from './pages/34-ProduitsCollectivite'
import TailleCollectivitePage from './pages/35-TailleCollectivite'
import CollectiviteDetailsPage from './pages/36-CollectiviteDetails'
import PricingMreAcheelPage from './pages/37-PricingMREAcheel'
import MRPBuildingInfoAddressPage from './pages/38-MREBuildingInfoAddress'
import FinalizationPage from './pages/39-Finalization'

// import CheckoutPciPage from './pages/33-CheckoutAcheel'
// import TailleEntreprisePage from './pages/35-TailleEntreprise'

import { type OnboardingWorkflowPath, useOnboardingWorkflow } from './workflow'

type OnboardingRoute<T extends string = string> = {
  path: T
  main: React.ReactNode
  tips?: React.ReactNode
}

export type OnboardingPage = Pick<OnboardingRoute, 'main' | 'tips'>

const Catch = () => {
  const { nextStep, initialStep } = useOnboardingWorkflow()

  return <Navigate to={(nextStep || initialStep)?.[0] ?? '/'} replace />
}

// We might want to expand this config to be able to nest routes for context or other reasons.
const routes = [
  {
    path: 'bienvenue',
    ...WelcomePage,
  },
  {
    path: 'company',
    ...CompanyPage,
  },
  {
    path: 'company-details',
    ...CompanyDetailsPage,
  },
  {
    path: 'turnover',
    ...TurnoverPage,
  },
  {
    path: 'personal-informations',
    ...PersonalInformationsPage,
  },
  {
    path: 'activity',
    ...ActivityPage,
  },
  {
    path: 'produits-professionnel',
    ...ProduitsProfessionnelPage,
  },
  {
    path: 'heyflow',
    ...HeyflowPage,
  },
  {
    path: 'ecommerce-turnover',
    ...EcommerceTurnoverPage,
  },
  {
    path: 'mrp-building-address',
    ...MRPBuildingAddressPage,
  },
  {
    path: 'mrp-building-information',
    ...MRPBuildingInformationsPage,
  },
  {
    path: 'loading',
    ...LoadingPage,
  },
  {
    path: 'tailored--cover-date',
    ...TailoredCoverDatePage,
  },
  {
    path: 'tailored--book-meeting',
    ...TailoredBookMeetingPage,
  },
  {
    path: 'tailored--finalization',
    ...TailoredFinalizationPage,
  },
  {
    path: 'pricing-rcp',
    ...PricingRCPPage,
  },
  {
    path: 'pricing-ecomm',
    ...PricingEcommPage,
  },
  {
    path: 'pricing-mrp',
    ...PricingMRPPage,
  },
  {
    path: 'termination',
    ...TerminationPage,
  },
  {
    path: 'start-date',
    ...StartDatePage,
  },
  {
    path: 'summary',
    ...SummaryPage,
  },
  {
    path: 'authenticate',
    ...AuthenticatePage,
  },
  {
    path: 'otp',
    ...OtpPage,
  },
  {
    path: 'checkout',
    ...CheckoutPage,
  },
  {
    path: 'signature',
    ...SignaturePage,
  },
  {
    path: 'success',
    ...SuccessPage,
  },
  {
    path: 'adresse-logement',
    ...AsdBuildingAddressPage,
  },
  {
    path: 'prix-asd',
    ...PricingAsdPage,
  },
  {
    path: 'user-type',
    ...UserTypePage,
  },
  {
    path: 'produits-particulier',
    ...ProduitsParticulierPage,
  },
  {
    path: 'adresse-entreprise',
    ...AsdProBuildingAddressPage,
  },
  {
    path: 'prix-asdPro',
    ...PricingAsdProPage,
  },
  // {
  //   path: 'taille-entreprise',
  //   ...TailleEntreprisePage,
  // },
  {
    path: 'utilisateur-pci',
    ...UserTypePciPage,
  },
  {
    path: 'produits-collectivite',
    ...ProduitsCollectivitePage,
  },
  {
    path: 'taille-collectivite',
    ...TailleCollectivitePage,
  },
  {
    path: 'collectivite-details',
    ...CollectiviteDetailsPage,
  },
  {
    path: 'mrp-building-info-address',
    ...MRPBuildingInfoAddressPage,
  },
  {
    path: 'prix-mre',
    ...PricingMreAcheelPage,
  },
  {
    path: 'finalization',
    ...FinalizationPage,
  },

  {
    path: '*',
    main: <Catch />,
    tips: null,
  },
] as const satisfies readonly OnboardingRoute<OnboardingWorkflowPath | '*'>[]

export const MainContentRoutes = () => (
  <Routes>
    {routes.map((route) => (
      <Route key={route.path} path={route.path} element={route.main} />
    ))}
  </Routes>
)

export const TipsRoutes = () => (
  <Routes>
    {routes.map((route) => (
      <Route key={route.path} path={route.path} element={route.tips} />
    ))}
  </Routes>
)
